import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

export const usePrefersReducedMotion = (): boolean => {
    const getPreference = () => {
        if (typeof window === 'undefined') {
            return false
        }

        return window.matchMedia(QUERY).matches
    }

    const [prefersReducedMotion, setPrefersReducedMotion] = useState<boolean>(getPreference)

    useEffect(() => {
        if (typeof window === 'undefined') {
            return
        }

        const mediaQueryList = window.matchMedia(QUERY)
        const listener = (event: MediaQueryListEvent) => setPrefersReducedMotion(event.matches)

        mediaQueryList.addEventListener('change', listener)

        setPrefersReducedMotion(mediaQueryList.matches)

        return () => {
            mediaQueryList.removeEventListener('change', listener)
        }
    }, [])

    return prefersReducedMotion
}

